import React from 'react';
import {
    FormField, FormItem, FormLabel, FormControl, FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import {
    Select, SelectTrigger, SelectValue, SelectContent, SelectItem,
} from '@/components/ui/select';

const COUNTRIES = [
    { code: 'IN', name: 'India' },
    { code: 'US', name: 'United States' },
    { code: 'GB', name: 'United Kingdom' },
    { code: 'CA', name: 'Canada' },
    { code: 'AU', name: 'Australia' },
    { code: 'SG', name: 'Singapore' },
    { code: 'AE', name: 'UAE' },
];

/**
 * Billing address sub-form. Receives the parent react-hook-form instance.
 * @param {{ form: import('react-hook-form').UseFormReturn }} props
 */
export function BillingAddressForm({ form }) {
    return (
        <div className="space-y-4 p-4 bg-slate-50 border border-slate-200 rounded-sm" data-testid="billing-address-form">
            <h3 className="text-sm font-semibold text-slate-700">Billing Address</h3>

            <FormField
                control={form.control}
                name="billingAddress.line1"
                render={({ field }) => (
                    <FormItem>
                        <FormLabel htmlFor="billing-line1">Address Line 1</FormLabel>
                        <FormControl>
                            <Input id="billing-line1" placeholder="Street address, P.O. box" autoComplete="billing address-line1" {...field} />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />

            <FormField
                control={form.control}
                name="billingAddress.line2"
                render={({ field }) => (
                    <FormItem>
                        <FormLabel htmlFor="billing-line2">Address Line 2 <span className="text-slate-400">(optional)</span></FormLabel>
                        <FormControl>
                            <Input id="billing-line2" placeholder="Apartment, suite, unit" autoComplete="billing address-line2" {...field} />
                        </FormControl>
                    </FormItem>
                )}
            />

            <div className="grid grid-cols-2 gap-4">
                <FormField
                    control={form.control}
                    name="billingAddress.city"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel htmlFor="billing-city">City</FormLabel>
                            <FormControl>
                                <Input id="billing-city" placeholder="City" autoComplete="billing address-level2" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="billingAddress.state"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel htmlFor="billing-state">State / Province</FormLabel>
                            <FormControl>
                                <Input id="billing-state" placeholder="State" autoComplete="billing address-level1" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />
            </div>

            <div className="grid grid-cols-2 gap-4">
                <FormField
                    control={form.control}
                    name="billingAddress.zip"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel htmlFor="billing-zip">ZIP / Postal Code</FormLabel>
                            <FormControl>
                                <Input id="billing-zip" placeholder="ZIP code" autoComplete="billing postal-code" inputMode="numeric" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="billingAddress.country"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel>Country</FormLabel>
                            <Select onValueChange={field.onChange} defaultValue={field.value}>
                                <FormControl>
                                    <SelectTrigger aria-label="Select country" data-testid="select-country">
                                        <SelectValue placeholder="Select country" />
                                    </SelectTrigger>
                                </FormControl>
                                <SelectContent>
                                    {COUNTRIES.map((c) => (
                                        <SelectItem key={c.code} value={c.code}>{c.name}</SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>
                            <FormMessage />
                        </FormItem>
                    )}
                />
            </div>
        </div>
    );
}

export default BillingAddressForm;
